module.exports = __webpack_public_path__ + "img/待收货.a31cde36.jpg";